import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTASectionProps {
  onOrderClick?: () => void;
}
export function CTASection({
  onOrderClick
}: CTASectionProps) {
  return <section className="py-24 bg-gradient-to-br from-accent-purple to-accent-pink text-white relative overflow-hidden" data-id="element-125">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-126" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-127" />

      <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-129">
          <h2 className="text-4xl md:text-6xl font-serif italic mb-6 leading-tight" data-id="element-130">
            Ready to Capture Every Toast?
          </h2>
          <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-131">
            Create your audio guestbook in minutes. No rentals, no hassle, just
            heartfelt messages from the people you love.
          </p>

          <div className="flex flex-col items-center space-y-4" data-id="element-132">
            <button onClick={onOrderClick} className="bg-white text-brown-900 text-sm font-bold tracking-widest uppercase px-10 py-5 rounded-full hover:shadow-xl hover:scale-105 transition-all duration-300 flex items-center space-x-2 group" data-id="element-133">
              <span data-id="element-134">Get Started Free</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-135" />
            </button>
            <p className="text-sm font-medium text-white/80" data-id="element-136">
              Free to try · No credit card required
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}